/**
 * Downloads a file from the browser
 *
 * @param documentName - The name of the file
 * @param {Blob} data - The response data that contains the file content
 * @param callback - A function that triggers after the download
 */
export function donwloadDefaultFile(
  documentName: string,
  data: Blob,
  callback?: () => void
) {
  const url = window.URL.createObjectURL(data);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = documentName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  if (callback) {
    callback();
  }
}
